export const getManagedLabel = (isManaged) => {
    return isManaged ? 'Eigenes Gerüst' : 'Fremdes Gerüst';
}

export const getManagedExplanationLabel = (isManaged) => {
    return isManaged ? 'Gerüst des eigenen Unternehmens' : 'Gerüst eines anderen Unternehmens';
}
